// extracted by mini-css-extract-plugin
export default {"footer":"css-QGO+1Y76hg","gradientRotate":"css-awm3dZ8XYj","footer_inner":"css-46T-2z65YN","footer_inner_column":"css-nJ5Wb6D2EZ","footer_inner_column__width6":"css-eiq7tYyny0"};